import React, { FC, useEffect } from 'react';
import { ISuggestionList } from './types';

const SuggestionList: FC<ISuggestionList> = ({
  setState,
  name,
  onSelect,
  state,
  shouldOpen,
}) => {
  const { suggestionOptions, noResultsFound, isLoading } = state;

  // Close suggestions when clicking outside of the search input
  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      const target = event.target as HTMLInputElement;
      if (target.name === name) {
        return;
      }

      setState(prevState => ({
        ...prevState,
        showDropDown: false,
      }));
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!shouldOpen || !suggestionOptions || isLoading) {
    return null;
  }

  return (
    <div className="searchable-field__suggest-list">
      <ul>
        {noResultsFound ? (
          <li>No results found</li>
        ) : (
          suggestionOptions.map((option, index) => {
            const suggestion = `${option.name}, ${option.country}`;
            return (
              <li
                value={option.id}
                key={index}
                onClick={() =>
                  onSelect({
                    id: option.id,
                    name: suggestion,
                  })
                }
              >
                {suggestion}
              </li>
            );
          })
        )}
      </ul>
    </div>
  );
};

export default SuggestionList;
